import React from 'react';

import dialogActions from '../../../hooks/useDialog/dialogActions';

import * as styles from './ModalMask.module.scss';

interface props {
    onClick: ()=> void,
    status: dialogActions
}

const ModalMask = ({ onClick, status }: props): JSX.Element => {
    const animationClassName = status === dialogActions.open ? styles.ModalMaskIn : styles.ModalMaskOut;

    return (
        <button
            type="button"
            aria-hidden
            tabIndex={-1}
            onClick={onClick}
            className={`${styles.ModalMask} ${animationClassName}`}
        >
            Close
        </button>
    );
};

export default ModalMask;
